const defaultState = {
    tags: {
        title: 'BoxUp Shopify App Development',
        description: "Building apps to make things simpler for you.",
        meta: {
            charset: 'utf-8',
            name: {
                keywords: 'BoxUp, Shopify, shopify app developer, shopify apps'
            }
        }
    }
}

export default function meta (state = defaultState, action) {
    switch(action.type) {
        case "SET_TAGS":
            return {
                ...state,
                tags: action.payload.tags
            }
        case "RESET_TAGS":
            return {
                ...state,
                tags: defaultState.tags
            }
        default:
            return state;
    }
}